import { CustomTabPanel } from "@/erp/sale"
import { a11yProps, EstadosOrdenTrabajoEnumChoice, useTabsFormOnly } from "@/shared"
import { FormTabsOnly, SingleBoxTableTabsOnly, SingleTableBoxScene } from "@/shared/components/ui"
import { Tab } from "@mui/material"
import TableActivacionCorporativoInstalacion from "../../shared/component/TableActivacionCorporativoInstalacion"

export const InstalacionCorporativosPage = () => {
  const { handleMethodChange, valueTab } = useTabsFormOnly({})
  return (

    <SingleTableBoxScene title="Activación Corporativo">
      <SingleBoxTableTabsOnly>
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="Asignadas" value={1} {...a11yProps(1)} />
          <Tab label="Reasignadas" value={2} {...a11yProps(2)} />
          <Tab label="Realizadas" value={3} {...a11yProps(3)} />
          <Tab label="Fallidas" value={4} {...a11yProps(4)} />
        </FormTabsOnly>
      </SingleBoxTableTabsOnly>
      <CustomTabPanel value={valueTab} index={1}>
        <TableActivacionCorporativoInstalacion
          stateAgendamiento={EstadosOrdenTrabajoEnumChoice.EN_ESPERA}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <TableActivacionCorporativoInstalacion
          stateAgendamiento={EstadosOrdenTrabajoEnumChoice.ESPERA_RECOORDINADA}
        />
      </CustomTabPanel>
    </SingleTableBoxScene>
  )
}
export default InstalacionCorporativosPage;